import React from "react";
import { string, oneOf, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import "./message-view.m.css";

const MessageView = ({ text, type, publisherAttributes }) => {
  if (!text) {
    return null;
  }

  return (
    <div styleName={`${type} ${publisherAttributes.lang}-wrapper`} className={`${type}-wrapper`}>
      {text}
    </div>
  );
};

MessageView.defaultProps = {
  type: "error",
};

MessageView.propTypes = {
  text: string,
  type: oneOf(["success", "error"]),
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps)(MessageView);
